import React, { useState } from 'react';
import { TextButton, Box } from 'wix-style-react';
import { useBiLogger } from '../../../useBiLogger';
import s from '../main-header.scss';
import { devCenterHeaderNavigationClick } from '@wix/bi-logger-developer-center/v2';
export const LinkItem = ({ id, text, target = 'same-window', href, active = false, }) => {
    const biLogger = useBiLogger();
    const [hovered, setHovered] = useState(false);
    return (React.createElement(Box, { dataHook: id, className: s.navLinkNewStyle },
        React.createElement(TextButton, { onClick: () => {
                biLogger.report(devCenterHeaderNavigationClick({
                    link_name: text,
                }));
                if (typeof href === 'string') {
                    if (target === 'new-window') {
                        window.open(href);
                    }
                    else {
                        window.location.href = href;
                    }
                }
            }, skin: active || hovered ? 'standard' : 'dark', onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) }, text)));
};
//# sourceMappingURL=LinkItem.js.map